import React from "react";

/**
 * The brand's divine signature: hairline — 5px diamond — hairline.
 * Used above the eyebrow inside every video band and as a divider between
 * major light sections. Hairline weight only, never thick.
 */
export function Ornament({ className = "", tone = "var(--c-gold-bright)", width = 60 }) {
  return (
    <span
      className={`flex items-center justify-center gap-3 ${className}`}
      aria-hidden="true"
      data-testid="ornament"
    >
      <span style={{ width, height: 1, background: tone, opacity: 0.55 }} />
      <span style={{ width: 5, height: 5, background: tone, transform: "rotate(45deg)" }} />
      <span style={{ width, height: 1, background: tone, opacity: 0.55 }} />
    </span>
  );
}
